export default __webpack_public_path__ + "../staticImages/novomind_logo.png";